/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import Title from '@cashew/title';
import Box from '@cashew/box';
import { useEnterListener } from '@cashew/hooks';
import Emptylist from '@cashew/list-empty';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '@cashew/pagination';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import { BRAND_COLORS } from '../../config/brand';
import './index.css';
import {
  Button,
  Input,
  Modal,
  PageWithNavigation,
  Tag,
} from '../../components';
import ExportModal from './ExportModal';
import styles from './index.scss';
import { Tooltip } from '../../components/Tooltip';
import getFormattedOutstandingStatus from './outstanding.functions';
import SelectComponent from '../../components/SelectComponent';

const { api, dateFormat, priceFormat } = require('@cashew/utils');

const searchByList = [
  {
    key: 'Order ID',
    value: 'Order ID',
  },
  {
    key: 'Merchant order code',
    value: 'Merchant order code',
  },
  {
    key: 'Installment ID',
    value: 'Installment ID',
  },
];

const ns = 'outstandings';

const numericInput = /^[0-9]+$/;

export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [list, setList] = useState<any | undefined>([]);
  const [userCards, setUserCards] = useState<any | undefined>([]);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [merchants, setMerchants] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const [searchId, setSearchId] = useState<any | undefined>();
  const [showLateFeeModal, setShowLateFeeModal] = useState(false);
  const [showManuallyChargeModal, setShowManuallyChargeModal] = useState(false);
  const [cardsLoading, setCardsLoading] = useState(false);
  const [selectedOutstanding, setSelectedOutstanding] = useState<
    any | undefined
  >();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [feeComment, setFeeComment] = useState('');
  const [searchBy, setSearchBy] = useState('Order ID');
  const [sortBy, setSortBy] = useState('1');
  const [merchant, setMerchant] = useState<any | undefined>('0');
  const [error, setError] = useState('');
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [enterBtn, setEnterBtn] = useState(false);
  const [cashPaymentModal, setCashPaymentModal] = useState<boolean>(false);
  const formRef = useRef<HTMLFormElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [cardHolderError] = useState<any>('');
  const [cardHolder, setCardHolder] = useState<any>('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cardHolderName, setCardHolderName] = useState<any>('');
  const [cardNumberError, setCardNumberError] = useState<any>('');
  const [expiryDateError, setExpiryDateError] = useState<any>('');
  const [cvvError, setCvvError] = useState('');
  const globalThis: any = global;
  const cardHolderReg = /^[A-Za-z\s]*$/;
  const { token } = useSelector((state: any) => state.user);
  const [ckoCardToken, setCkoCardToken] = useState('');

  useEnterListener(() => setEnterBtn((prev) => !prev));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get('status');
  const responseMessage = queryParams.get('responseMessage');

  useEffect(() => {
    if (status === 'success') {
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: 'Success',
          toasterMessage: 'Cash payment successfully charged.',
          toasterType: 'success',
          toasterVisible: true,
          toasterDismiss: null,
        },
      });
    }
    if (status === 'error') {
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: 'Cash payment error',
          toasterMessage: responseMessage,
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      });
    }
  }, [status]);

  useEffect(() => {
    if (cashPaymentModal) {
      setCardHolder('');
      const script = document.createElement('script');
      script.src = 'https://cdn.checkout.com/js/framesv2.min.js';
      script.async = true;
      document.body.appendChild(script);
      globalThis.CKOConfig = {
        publicKey: process.env.REACT_APP_CHECKOUT_KEY,
        namespace: 'Checkout',
        style: {
          base: {
            fontFamily: "'Open Sans', sans-serif;",
            letterSpacing: 0,
            color: 'black',
            border: '1px solid #cfcfcf',
            borderRadius: '3px',
            height: '100%',
            marginBottom: '20px',
            paddingLeft: '1rem',
          },
          focus: {
            border: `1px solid ${BRAND_COLORS.primary}`,
            color: 'black',
          },
          // @ts-ignore
          hover: {
            border: '1px solid #787878',
          },
          invalid: {
            border: '1px solid #ff332b',
            color: 'black',
          },
          placeholder: {
            base: {
              color: '#8f8f8f',
            },
            focus: {
              color: BRAND_COLORS.primary,
            },
          },
        },
        frameValidationChanged(e: any) {
          const el = e.element;

          switch (el) {
            case 'card-number': {
              setCardNumberError(e.isValid ? '' : 'Please insert a card');
              break;
            }
            case 'expiry-date': {
              setExpiryDateError(
                e.isValid ? '' : 'Please insert an expiry date'
              );
              break;
            }
            case 'cvv': {
              setCvvError(e.isValid ? '' : 'Please insert a cvv code');
              break;
            }
            default:
              break;
          }
        },
        ready() {
          /* istanbul ignore else */
          if (formRef.current) {
            // Frames is registered on the global namespace and safe to use
            formRef.current.addEventListener('submit', (event: any) => {
              event.preventDefault();
              globalThis.Checkout.submitCard();
            });
          }
        },
        cardValidationChanged(event: any) {
          console.log('CARD_VALIDATION_CHANGED: %o', event);
          // if all fields contain valid information, the Pay now
          // button will be enabled and the form can be submitted
          /* istanbul ignore else */
          if (buttonRef.current) {
            buttonRef.current.disabled = !globalThis.Checkout.isCardValid();
          }
        },
        cardSubmitted() {
          /* istanbul ignore else */

          // console.log(globalThis.Checkout);
          if (buttonRef.current) {
            buttonRef.current.disabled = true;
          }
          // display loader
        },
        cardTokenized(data: any) {
          console.log('CARD_TOKENIZED: %o', data);
          // add card token to the form
          setCardHolderName(data.name);

          globalThis.Checkout.addCardToken(formRef.current, data.token);
          // submit the form
          /* istanbul ignore else */
          // if (formRef.current) {
          //   formRef.current.submit();
          // }

          setCkoCardToken(data.token);
          setCardHolderName(data?.name);
          setTimeout(() => {
            if (formRef.current && data.token) {
              formRef.current.submit();
            }
          }, 1000);
        },
      };
    }
  }, [cashPaymentModal]);

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);
  useEffect(() => {
    api
      .get({
        endpoint: 'identity/merchants',
        params: {
          size: 100,
        },
      })
      .then((resp: any) => {
        // if (resp?.data !== {}) {
        const listMerchants = resp?.data?.map((item: any) => ({
          key: item.id,
          value: item.companyName ? item.companyName : item.id.toString(),
        }));

        listMerchants.sort((firstElement: any, secondElement: any) => {
          const firstElementValue = firstElement.value.toUpperCase();
          const secondElementValue = secondElement.value.toUpperCase();
          // eslint-disable-next-line no-nested-ternary
          return firstElementValue === secondElementValue
            ? 0
            : firstElementValue > secondElementValue
              ? 1
              : -1;
        });

        setMerchants(listMerchants);
        // }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, []);
  const getOrdersApi = (resetPageNumber = true) => {
    const trimSearch = searchId?.trim();
    // update the page only if we changed the filters and the page was not first page
    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }
    api
      .get({
        endpoint: 'products/reports/outstanding',
        params: {
          orderId: searchBy === 'Order ID' ? trimSearch : null,
          reference: searchBy === 'Merchant order code' ? trimSearch : null,
          installmentId: searchBy === 'Installment ID' ? trimSearch : null,
          sort: sortBy === '1' ? 'chargeDate,desc' : 'chargeDate,asc',
          merchantId: merchant > 0 ? merchant : null,
          page: searchId ? 0 : pageNumber,
          size: pageSize,
        },
      })
      .then((resp: any) => {
        const { data } = resp;
        setRecords(resp.totalCount);
        const dataList = data.map((item: any) => ({
          ...item,
          status: getFormattedOutstandingStatus({ item }),
        }));
        setList(dataList);
        setError('');
      })
      .catch((e: any) => {
        setError(e.response.data.errorCode);
      });
  };
  useEffect(() => {
    getOrdersApi(true);
  }, [merchant, sortBy]);
  useEffect(() => {
    getOrdersApi(false);
  }, [pageNumber, pageSize, enterBtn]);

  const getCustomerCardsAPI = ({ customerId, orderId }: any) => {
    setCardsLoading(true);
    api
      .get({
        endpoint: `payments/${customerId}/cards?orderId=${orderId}`,
      })
      .then((resp: { data: any }) => {
        setUserCards(resp.data);
        if (resp?.data?.length > 0) {
          const defaultCard = resp?.data?.find((x: any) => x?.isDefault);
          setSelectedCard(
            defaultCard ? defaultCard?.paymentId : resp?.data[0]?.paymentId
          );
        }
        setShowManuallyChargeModal(true);
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(() => {
        setCardsLoading(false);
      });
  };

  const getExcelReport = () => {
    api
      .get({
        endpoint: 'products/reports/outstanding/csv',
        params: {
          orderId: searchBy === 'Order ID' && searchId ? searchId : null,
          merchantId: merchant === '0' ? null : merchant,
          reference: searchBy === 'Merchant order code' ? searchId : null,
          installmentId: searchBy === 'Installment ID' ? searchId : null,
        },
      })
      .then((response: any) => {
        const a = document.createElement('a');
        a.href = response.data;
        document.body.appendChild(a);
        a.click();
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const handleCashPayment = (e: any) => {
    e.preventDefault();
    setCashPaymentModal(true);
  };

  const handleSelectChange = (selectedKey: string) => {
    setSearchId('');
    setSearchBy(selectedKey);
  };

  return (
    <div className={ns}>
      <Helmet>
        <title>{t('outstanding.sectionTitle')}</title>
      </Helmet>
      <PageWithNavigation>
        <Title>
          <span>{t('outstanding.title')}</span>

          <span>
            <Button
              extraClass="blue show-filter-btn"
              onClick={() => setShowFilter(!showFilter)}
            >
              <div className="btn-with-icon">
                <img src="/fillter.svg" alt="filter" />
                Filters
              </div>
            </Button>
          </span>
        </Title>
        <div className={cn({ 'hide-filter': !showFilter })}>
          <div className="filters">
            <div className="filter-group">
              <div className="filter-input">
                <SelectComponent
                  label="Search by"
                  data={searchByList}
                  selected={searchBy}
                  onSelect={handleSelectChange}
                />
              </div>
              <div className="filter-input">
                <Input
                  name="search"
                  value={searchId}
                  type="text"
                  maxLength={searchBy === 'Order ID' ? 14 : 100}
                  onChange={(e: any) => {
                    const searchValue = e.target.value;
                    if (
                      searchBy === 'Order ID' ||
                      searchBy === 'Installment ID'
                    ) {
                      if (
                        searchValue.match(numericInput) ||
                        searchValue === ''
                      ) {
                        setSearchId(searchValue);
                      }
                    } else {
                      setSearchId(searchValue);
                    }
                  }}
                />
              </div>
              <div className="filter-input">
                <Button extraClass="btn blue" onClick={getOrdersApi}>
                  {t('outstanding.sectionFilter.searchBtn')}
                </Button>
              </div>
            </div>

            <div className="filter-group">
              <div className="filter-input">
                <SelectComponent
                  label="Sort by due date"
                  data={[
                    {
                      key: '1',
                      value: 'Newest to oldest',
                    },
                    {
                      key: '2',
                      value: 'Oldest to newest',
                    },
                  ]}
                  selected={sortBy}
                  onSelect={setSortBy}
                />
              </div>
              <div className="filter-group">
                <div className="filter-input">
                  <SelectComponent
                    label={t('settlements.sectionFilter.merchant')}
                    data={[
                      {
                        key: '0',
                        value: 'All',
                      },
                      ...merchants,
                    ]}
                    selected={merchant}
                    onSelect={setMerchant}
                  />
                </div>
                <div className="filter-input">
                  <Button
                    extraClass="blue"
                    onClick={() => setShowCancelModal(true)}
                  >
                    {t('outstanding.sectionFilter.exportToExcel')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Box withHeader className={`${ns}__box`}>
          <div>
            <div className={`${ns}__headers`}>
              <p>{t('outstanding.table.column.merchantName')}</p>
              <p>{t('outstanding.table.column.customerID')}</p>
              <p>{t('outstanding.table.column.orderId')}</p>
              <p>{t('outstanding.table.column.orderDate')}</p>
              <p>{t('outstanding.table.column.orderStatus')}</p>
              <p>{t('outstanding.table.column.type')}</p>
              <p>{t('outstanding.table.column.orderAmount')}</p>
              <p>{t('outstanding.table.column.dueDate')}</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    t('outstanding.table.column.installmentAmount')
                  ),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    t('outstanding.table.column.latePaymentFee')
                  ),
                }}
              />
              <p>{t('outstanding.table.column.attempts')}</p>
              <p />
              <p />
            </div>
            {list.length > 0 && !error ? (
              <ul className="list">
                {list?.map((listItem: any, key: any) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={key}>
                    <div
                      className={`${ns}__row`}
                      role="row"
                      tabIndex={0}
                      onKeyDown={undefined}
                    >
                      <div
                        className="three-dots"
                        title={listItem.merchantName || t('filed.empty')}
                      >
                        {listItem.merchantName || t('filed.empty')}
                      </div>
                      <div>
                        <Tooltip
                          content={
                            <div className="tooltip__text">
                              <h2>
                                {t('outstanding.table.column.customerID')}{' '}
                                {listItem.customerId || t('filed.empty')}
                              </h2>
                              <p>
                                <strong>
                                  {t('outstanding.table.column.emailAddress')}:{' '}
                                </strong>
                                <span>
                                  {listItem.email || t('filed.empty')}
                                </span>
                              </p>
                              <p>
                                <strong>
                                  {t('outstanding.table.column.mobileNumber')}:{' '}
                                </strong>
                                <span>
                                  {listItem.mobileNumber || t('filed.empty')}
                                </span>
                              </p>
                            </div>
                          }
                        >
                          {listItem.customerId || t('filed.empty')}
                        </Tooltip>
                      </div>
                      <div>
                        <Tooltip
                          content={
                            <div className="tooltip__text">
                              <h2>
                                {t('outstanding.table.column.orderId')}{' '}
                                {listItem.orderId || t('filed.empty')}
                              </h2>
                              <p>
                                <strong>
                                  {t('outstanding.table.column.installmentID')}:{' '}
                                </strong>
                                <span>
                                  {listItem.installmentId || t('filed.empty')}
                                </span>
                              </p>
                              <p>
                                <strong>
                                  {t(
                                    'outstanding.table.column.merchantOrderCode'
                                  )}
                                  :{' '}
                                </strong>
                                <span>
                                  {listItem.orderReference || t('filed.empty')}
                                </span>
                              </p>
                            </div>
                          }
                        >
                          {listItem.orderId || t('filed.empty')}
                        </Tooltip>
                      </div>
                      <div>
                        {dateFormat({ date: listItem.orderDate }) ||
                          t('filed.empty')}
                      </div>
                      <div>
                        <Tag status={listItem.status}>
                          {t<string>(`status.${listItem.status}`)}
                        </Tag>
                      </div>
                      <div>{listItem.type || t('filed.empty')}</div>
                      <div>
                        {`${priceFormat({
                          currency: listItem.currencyCode,
                          amount: listItem.orderAmount,
                        })}` || t('filed.empty')}
                      </div>
                      <div>
                        {dateFormat({ date: listItem.chargeDate }) ||
                          t('filed.empty')}
                      </div>
                      <div>
                        {`${priceFormat({
                          currency: listItem.currencyCode,
                          amount: listItem.installmentAmount,
                        })}` || t('filed.empty')}
                      </div>
                      <div>
                        {`${priceFormat({
                          currency: listItem.currencyCode,
                          amount:
                            listItem.latePaymentFee +
                            listItem.latePaymentAmountVat,
                        })}` || t('filed.empty')}
                      </div>
                      <div>{listItem.numberOfAttempts || t('filed.empty')}</div>
                      <div className="actions">
                        {listItem.totalToBeCollected > 0 &&
                          listItem.installmentStatus === 'PENDING' &&
                          listItem.orderStatus === 'CONFIRMED' && (
                            <Button
                              loading={
                                cardsLoading &&
                                selectedOutstanding.customerId ===
                                  listItem.customerId
                              }
                              onClick={() => {
                                setSelectedOutstanding(listItem);
                                getCustomerCardsAPI({
                                  customerId: listItem.customerId,
                                  orderId: listItem.orderId,
                                });
                              }}
                            >
                              {t('outstanding.cta.manuallyCharge')}
                            </Button>
                          )}
                      </div>
                      <div className="actions">
                        <Button
                          extraClass="blue"
                          disabled={listItem.isLateFeeReversed}
                          onClick={() => {
                            setSelectedOutstanding(listItem);
                            setShowLateFeeModal(true);
                          }}
                        >
                          {t('outstanding.cta.reverseLateFee')}
                        </Button>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <Emptylist text="" />
            )}
            <Pagination
              records={records}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              changePageSize={setPageSize}
            />
          </div>
        </Box>
      </PageWithNavigation>

      {showLateFeeModal && selectedOutstanding !== undefined && (
        <Modal
          className="reversal-modal"
          isVisible={showLateFeeModal}
          onClose={() => {
            setShowLateFeeModal(false);
          }}
        >
          <div className="modal-header">
            <h2>Reverse Late Fee</h2>
            <p>
              <strong>{t('outstanding.table.column.customerID')}:</strong>
              {selectedOutstanding.customerId}
            </p>
            <p>
              <strong>{t('outstanding.table.column.emailAddress')}:</strong>
              {selectedOutstanding.email}
            </p>
            <p>
              <strong>{t('outstanding.table.column.mobileNumber')}:</strong>
              {selectedOutstanding.mobileNumber}
            </p>
          </div>

          <div className="modal-content">
            <div className="late-payment-fee">
              <h1>
                {priceFormat({
                  currency: selectedOutstanding.currencyCode,
                  amount:
                    selectedOutstanding.latePaymentFee +
                    selectedOutstanding.latePaymentAmountVat,
                })}
              </h1>
              <p>Late fee amount including VAT</p>
            </div>

            <div className="row">
              <div className="column">
                <p>
                  <strong>
                    {t('outstanding.table.column.orderId')}: &nbsp;
                  </strong>
                  {selectedOutstanding.orderId}
                </p>
              </div>
              <div className="column">
                <p>
                  <strong>{t('outstanding.table.column.orderAmount')}:</strong>
                  {selectedOutstanding.orderAmount}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="column">
                <p>
                  <strong>
                    {t('outstanding.table.column.installmentID')}: &nbsp;
                  </strong>
                  {selectedOutstanding.installmentId}
                </p>
              </div>
              <div className="column">
                <p>
                  <strong>{t('outstanding.column.installmentAmount')}:</strong>
                  {priceFormat({
                    currency: selectedOutstanding.currencyCode,
                    amount: selectedOutstanding.installmentAmount,
                  })}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="column">
                <p>
                  <strong>
                    {t('outstanding.table.column.totalToBeCollected')}:
                  </strong>
                  {priceFormat({
                    currency: selectedOutstanding.currencyCode,
                    amount:
                      selectedOutstanding.totalToBeCollected +
                      selectedOutstanding.latePaymentAmountVat,
                  })}
                </p>
              </div>
              <div className="column">
                <p>
                  <strong>
                    {t('outstanding.table.column.dueDate')}
                    :&nbsp;
                  </strong>
                  {selectedOutstanding.chargeDate}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="column">
                <p>
                  <strong>
                    {t('outstanding.table.column.merchantOrderCode')}: &nbsp;
                  </strong>
                  {selectedOutstanding.orderReference}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="column">
                <textarea
                  name="feeReversalComment"
                  rows={7}
                  placeholder={t('outstanding.modal.feeReversalComment')}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFeeComment(value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <p>
                You are about to reverse
                <strong>
                  {priceFormat({
                    currency: selectedOutstanding.currencyCode,
                    amount:
                      selectedOutstanding.latePaymentFee +
                      selectedOutstanding.latePaymentAmountVat,
                  })}
                </strong>{' '}
                from the order <strong>{selectedOutstanding.orderId}</strong>.
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              extraClass="btn-outline-black secondary"
              onClick={() => {
                setShowLateFeeModal(false);
              }}
            >
              {t('outstanding.modal.cancel')}
            </Button>

            <Button
              extraClass="blue"
              onClick={() => {
                api
                  .post({
                    endpoint: 'products/reports/outstanding/reverselatefee',
                    params: {
                      installmentId: selectedOutstanding.installmentId,
                      comment: feeComment,
                    },
                  })
                  .then((resp: any) => {
                    if (resp.status === 'success') {
                      const updatedListItem = list.find(
                        (listItem: any) =>
                          listItem.installmentId ===
                          selectedOutstanding.installmentId
                      );
                      updatedListItem.isLateFeeReversed = true;
                      setShowLateFeeModal(false);
                      dispatch({
                        type: 'OPEN_TOASTER',
                        payload: {
                          toasterTitle: 'Success',
                          toasterMessage: 'Late payment fee reversed ',
                          toasterType: 'success',
                          toasterVisible: true,
                          toasterDismiss: null,
                        },
                      });
                    } else {
                      dispatch({
                        type: 'OPEN_TOASTER',
                        payload: {
                          toasterTitle: 'Error',
                          toasterMessage: 'Cannot reverse the late fee',
                          toasterType: 'error',
                          toasterVisible: true,
                          toasterDismiss: null,
                        },
                      });
                    }
                  })
                  .catch((err: any) => {
                    console.log(err);
                    dispatch({
                      type: 'OPEN_TOASTER',
                      payload: {
                        toasterTitle: 'Error',
                        toasterMessage: 'Something is wrong with the server',
                        toasterType: 'error',
                        toasterVisible: true,
                        toasterDismiss: null,
                      },
                    });
                  });
              }}
            >
              {t('outstanding.cta.reverseLateFee')}
            </Button>
          </div>
        </Modal>
      )}

      {showManuallyChargeModal && selectedOutstanding !== undefined && (
        <Modal
          className="reversal-modal"
          isVisible={showManuallyChargeModal}
          onClose={() => {
            setShowManuallyChargeModal(false);
            setCashPaymentModal(false);
          }}
        >
          <>
            {!cashPaymentModal && (
              <>
                <div className="modal-header">
                  <h2>Manually charge installment</h2>
                  <p>
                    <strong>{t('outstanding.table.column.customerID')}:</strong>
                    {selectedOutstanding.customerId}
                  </p>
                  <p>
                    <strong>
                      {t('outstanding.table.column.emailAddress')}:
                    </strong>
                    {selectedOutstanding.email}
                  </p>
                  <p>
                    <strong>
                      {t('outstanding.table.column.mobileNumber')}:
                    </strong>
                    {selectedOutstanding.mobileNumber}
                  </p>
                </div>

                <div className="modal-content">
                  <div className="late-payment-fee">
                    <h1>
                      {priceFormat({
                        currency: selectedOutstanding.currencyCode,
                        amount:
                          selectedOutstanding.totalToBeCollected +
                          selectedOutstanding.latePaymentAmountVat,
                      })}
                    </h1>

                    <p>Manually charge amount (VAT included)</p>
                  </div>
                  <div className="row">
                    <div className="column">
                      <p>
                        <strong>
                          {t('outstanding.table.column.orderId')}:
                        </strong>
                        {selectedOutstanding.orderId}
                      </p>
                    </div>
                    <div className="column">
                      <p>
                        <strong>
                          {t('outstanding.table.column.orderAmount')}:
                        </strong>
                        {selectedOutstanding.orderAmount}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="column">
                      <p>
                        <strong>
                          {t('outstanding.table.column.installmentID')}:
                        </strong>
                        {selectedOutstanding.installmentId}
                      </p>
                    </div>
                    <div className="column">
                      <p>
                        <strong>
                          {t('outstanding.column.installmentAmount')}:
                        </strong>
                        {priceFormat({
                          currency: selectedOutstanding.currencyCode,
                          amount: selectedOutstanding.installmentAmount,
                        })}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="column">
                      <p>
                        <strong>
                          {t('outstanding.table.column.totalToBeCollected')}:
                        </strong>
                        {priceFormat({
                          currency: selectedOutstanding.currencyCode,
                          amount:
                            selectedOutstanding.totalToBeCollected +
                            selectedOutstanding.latePaymentAmountVat,
                        })}
                      </p>
                    </div>
                    <div className="column">
                      <p>
                        <strong>
                          {t('outstanding.table.column.dueDate')}: &nbsp;
                        </strong>
                        {selectedOutstanding.chargeDate}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="column">
                      <p>
                        <strong>
                          {t('outstanding.table.column.merchantOrderCode')}
                          :&nbsp;
                        </strong>
                        {selectedOutstanding.orderReference}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-8">
                      <SelectComponent
                        label=""
                        data={userCards?.map((card: any) => ({
                          key: card.paymentId,
                          value: card.cardNumber,
                        }))}
                        selected={selectedCard}
                        onSelect={setSelectedCard}
                      />
                    </div>
                    <div className="col col-4">
                      <Button
                        extraClass="cash-payment-btn"
                        onClick={handleCashPayment}
                      >
                        Cash payment
                      </Button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="column">
                      <textarea
                        name="feeReversalComment"
                        rows={7}
                        placeholder={t('outstanding.modal.feeReversalComment')}
                        onChange={(e) => {
                          const { value } = e.target;
                          setFeeComment(value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <p>
                      You are about to manually charge
                      <strong>
                        {priceFormat({
                          currency: selectedOutstanding.currencyCode,
                          amount:
                            selectedOutstanding.totalToBeCollected +
                            selectedOutstanding.latePaymentAmountVat,
                        })}
                      </strong>{' '}
                      from the order{' '}
                      <strong>{selectedOutstanding.orderId}</strong>.
                    </p>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    extraClass="btn-outline-black secondary"
                    onClick={() => {
                      setShowManuallyChargeModal(false);
                      setCashPaymentModal(false);
                    }}
                  >
                    {t('outstanding.modal.cancel')}
                  </Button>

                  <Button
                    extraClass="blue"
                    disabled={isDisable}
                    onClick={() => {
                      setIsDisable(true);
                      const { paymentId, provider } = userCards.filter(
                        (card: any) => card.paymentId === selectedCard
                      )[0];
                      api
                        .post({
                          endpoint: 'products/installments/manualcharge',
                          params: {
                            installmentId: selectedOutstanding.installmentId,
                            comment: feeComment,
                            paymentId,
                            provider,
                          },
                        })
                        .then((resp: any) => {
                          if (resp.status === 'success') {
                            const updatedListItem = list.find(
                              (listItem: any) =>
                                listItem.installmentId ===
                                selectedOutstanding.installmentId
                            );
                            updatedListItem.totalToBeCollected = 0;
                            setShowManuallyChargeModal(false);
                            setIsDisable(true);
                            dispatch({
                              type: 'OPEN_TOASTER',
                              payload: {
                                toasterTitle: 'Success',
                                toasterMessage: 'Manually charged ',
                                toasterType: 'success',
                                toasterVisible: true,
                                toasterDismiss: null,
                              },
                            });
                          } else {
                            dispatch({
                              type: 'OPEN_TOASTER',
                              payload: {
                                toasterTitle: 'Error',
                                toasterMessage: 'Cannot charge manually',
                                toasterType: 'error',
                                toasterVisible: true,
                                toasterDismiss: null,
                              },
                            });
                          }
                        })
                        .catch((err: any) => {
                          dispatch({
                            type: 'OPEN_TOASTER',
                            payload: {
                              toasterTitle: 'Error',
                              toasterMessage: t(err.response.data.message),
                              toasterType: 'error',
                              toasterVisible: true,
                              toasterDismiss: null,
                            },
                          });
                        })
                        .finally(() => setIsDisable(false));
                    }}
                  >
                    {t('outstanding.cta.manuallyCharge')}
                  </Button>
                </div>
              </>
            )}
            {cashPaymentModal && (
              <>
                <h2>
                  Pay the outstanding balance of
                  {priceFormat({
                    currency: selectedOutstanding.currencyCode,
                    amount:
                      selectedOutstanding.totalToBeCollected +
                      selectedOutstanding.latePaymentAmountVat,
                  })}
                </h2>
                <div className="payments-checkout">
                  <form
                    id="payment-form"
                    action={`${process.env.REACT_APP_API}products/installment/cash-payment?authToken=${token}&installmentId=${selectedOutstanding?.installmentId}`}
                    method="POST"
                    ref={formRef}
                  >
                    <div className="input-container card-number pb-1">
                      <div className="card-number-frame" />
                      <span className="error-message">{cardNumberError}</span>
                    </div>
                    <div className="col-12 mb-1 input-with-error position-relative">
                      <input
                        className="card-holder"
                        name="cardHolderName"
                        id="card_holder"
                        type="text"
                        required
                        placeholder={t('payment.cardHolder')}
                        maxLength={35}
                        onChange={(e: any) => {
                          const { value } = e.target;
                          if (cardHolderReg.test(value)) {
                            globalThis.Checkout.cardholder = {
                              name: value,
                            };
                            setCardHolder(value);
                          }
                        }}
                        value={cardHolder}
                      />
                      <span className="error-message">{cardHolderError}</span>
                    </div>
                    <div className="date-and-code">
                      <div>
                        <div className="input-container expiry-date">
                          <div className="expiry-date-frame" />
                          <span className="error-message">
                            {expiryDateError}
                          </span>
                        </div>
                      </div>

                      <div className="pb-1">
                        <div className="input-container cvv">
                          <div className="cvv-frame" />
                          <span className="error-message">{cvvError}</span>
                        </div>
                      </div>
                    </div>

                    <input
                      name="cko-card-token"
                      defaultValue={ckoCardToken}
                      hidden
                    />

                    <button
                      ref={buttonRef}
                      id="pay-button"
                      type="submit"
                      className={cn(styles.proceedPaymentButton, 'btn')}
                    >
                      Proceed with payment
                    </button>

                    <div>
                      <span className="error-message error-message__card-number" />
                      <span className="error-message error-message__expiry-date" />
                      <span className="error-message error-message__cvv" />
                    </div>
                    <p className="success-payment-message" />

                    <div
                      aria-hidden
                      className="back-click d-flex mx-2"
                      onClick={() => setCashPaymentModal(false)}
                    >
                      <p>Back to installment details</p>
                    </div>
                  </form>
                </div>
              </>
            )}
          </>
        </Modal>
      )}

      <ExportModal
        showConfirmModal={showCancelModal}
        setShowConfirmModal={setShowCancelModal}
        dispatch={dispatch}
        getExcelReport={getExcelReport}
        records={records}
      />
    </div>
  );
};
